module.exports = __webpack_public_path__ + "821b25ac7df2dcff81673c8a8dd0232f.jpg";